"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseChartDescriptor = void 0;
var constants_1 = require("../constants");
var drillDownUtil_1 = require("../drillDownUtil");
var BaseChartDescriptor = /** @class */ (function () {
    function BaseChartDescriptor() {
    }
    BaseChartDescriptor.prototype.getSizeInfo = function (_insight, layoutDescriptor, settings) {
        return {
            width: {
                default: 6,
                min: 4,
                max: layoutDescriptor.gridColumnsCount,
            },
            height: {
                default: this.getDefaultHeight(settings.enableKDWidgetCustomHeight),
                min: this.getMinHeight(settings.enableKDWidgetCustomHeight),
                max: this.getMaxHeight(settings.enableKDWidgetCustomHeight),
            },
        };
    };
    BaseChartDescriptor.prototype.getDefaultHeight = function (enableCustomHeight) {
        if (!enableCustomHeight) {
            return constants_1.DASHBOARD_LAYOUT_DEFAULT_VIS_HEIGHT;
        }
        return constants_1.MIDDLE_VISUALIZATION_HEIGHT;
    };
    BaseChartDescriptor.prototype.getMinHeight = function (enableCustomHeight) {
        if (!enableCustomHeight) {
            return constants_1.DASHBOARD_LAYOUT_DEFAULT_VIS_HEIGHT;
        }
        return constants_1.MIN_VISUALIZATION_HEIGHT;
    };
    BaseChartDescriptor.prototype.getMaxHeight = function (enableCustomHeight) {
        if (!enableCustomHeight) {
            return constants_1.DASHBOARD_LAYOUT_DEFAULT_VIS_HEIGHT;
        }
        return constants_1.MAX_VISUALIZATION_HEIGHT;
    };
    BaseChartDescriptor.prototype.applyDrillDown = function (insight, drillDownContext, backendSupportsElementUris) {
        var intersection = drillDownContext.event.drillContext.intersection;
        var withFilters = drillDownUtil_1.addIntersectionFiltersToInsight(insight, intersection, backendSupportsElementUris);
        return drillDownUtil_1.modifyBucketsAttributesForDrillDown(withFilters, drillDownContext.drillDefinition);
    };
    return BaseChartDescriptor;
}());
exports.BaseChartDescriptor = BaseChartDescriptor;
//# sourceMappingURL=BaseChartDescriptor.js.map